<ng-container *ngFor="let chip of labelsChips">
  <div class="chip">{{chip.key}}: {{chip.value}}</div>
</ng-container>
